import React, { useContext } from "react";
import CartStyle from "./CartStyle.module.css";
//import context
import { CartContext } from "../context/CartContextProvider";
//import components
import { ButtonError } from "../components/UI/Button";

//start functions
const Cart = (props) => {
  const { dispatch } = useContext(CartContext);
  const { title, cost, course, capacity } = props.data;
  return (
    <>
      <div className={CartStyle.container}>
        <div className={CartStyle.imageContainer}>
          <img
            alt="top"
            style={{ width: "100%" }}
            src={require(`../assets/products/${course.image}`).default}
          />
        </div>
        <div className={CartStyle.title}>
          <h3>{title}</h3>
        </div>
        <div className={CartStyle.teacher}>
          {" "}
          <h4>
            <span style={{ color: "orange", marginLeft: "2px" }}>مدرس</span>:
            <span style={{ marginRight: "2px" }}>محمدحسین پولانی</span>
          </h4>
        </div>
        <h4>
          <span style={{ color: "orange", marginLeft: "2px" }}>ظرفیت</span>:
          <span style={{ marginRight: "2px" }}>{capacity}</span>
          <h4>
            <span style={{ color: "orange", marginLeft: "2px" }}>قیمت</span>:
            <span style={{ marginRight: "2px", color: "green" }}>
              {cost}تومان
            </span>
          </h4>
        </h4>
       
        <ButtonError
          onClick={() => dispatch({ type: "REMOVE_ITEM", payload: props.data })}
        >حذف از سبد</ButtonError>
      </div>
    </>
  );
};

export default Cart;
